import { isTrackingAllowed } from "./analytics";

// Google Analytics (GA4) – Measurement ID kommt aus der verbundenen Verbindung.
const MEASUREMENT_ID = import.meta.env
  .VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY as string | undefined;

let initialized = false;
let listenerRegistered = false;

const bootGoogleAnalytics = () => {
  if (initialized || !MEASUREMENT_ID) return;
  initialized = true;

  if (
    !document.querySelector(
      `script[src*="googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}"]`,
    )
  ) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    // index.html definiert für Google Ads bereits ein globales gtag,
    // das arguments-Objekte in die dataLayer pusht – exakt dieses Format.
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments);
    };
  }

  window.gtag("js", new Date());
  // Page-Views senden wir selbst pro Route (SPA) über useAnalytics.
  window.gtag("config", MEASUREMENT_ID, { send_page_view: false });
};

/**
 * Consent-gated: GA lädt erst nach akzeptiertem Cookie-Consent und
 * erst nach First Paint (idle), damit es den kritischen Renderpfad
 * nicht blockiert. Das Google-Ads-gtag in index.html ist davon
 * unberührt und bleibt immer geladen.
 */
export const initGoogleAnalytics = () => {
  if (!MEASUREMENT_ID) return;

  if (isTrackingAllowed() && !initialized) {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(bootGoogleAnalytics, { timeout: 3000 });
    } else {
      setTimeout(bootGoogleAnalytics, 2000);
    }
  }

  if (!listenerRegistered) {
    listenerRegistered = true;
    window.addEventListener("cookieConsentChanged", ((e: CustomEvent) => {
      if (e.detail === "accepted") {
        // synchron booten, damit der direkt danach gesendete erste
        // page_view (useAnalytics) nicht verworfen wird
        bootGoogleAnalytics();
      }
    }) as EventListener);
  }
};

// SPA-Page-View pro Route (von useAnalytics aufgerufen).
export const gaTrackPageView = (path: string) => {
  if (!initialized || !MEASUREMENT_ID || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
  });
};
